export class PollingManager {
  constructor(apiUrl, itemId, updateCallback, finishedCallback) {
    this.apiUrl = apiUrl;
    this.itemId = itemId;
    this.updateCallback = updateCallback;
    this.finishedCallback = finishedCallback;
    this.pollInterval = null;
    this.attempts = 0;
  }

  async startPolling() {
    console.log("Started polling every 5s");
    await this.poll();
    this.pollInterval = setInterval(async () => {
      await this.poll();
    }, 5000);
  }

  stopPolling() {
    clearInterval(this.pollInterval);
    console.log("Stopped polling");
    this.finishedCallback(true);
  }

  async poll() {
    this.attempts++;
    let done = false;
    try {
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        body: JSON.stringify({"item_id": this.itemId})
      });
      const data = await response.json();
      const items = data.body.data;
      done = data.body.done;
      this.processItems(items);
    } catch (error) {
      console.error('Polling error:', error);
    } finally {
      if (done === true || this.attempts > 60) {
        this.stopPolling();
        return;
      }
    }
  }

  processItems(items) {
    const processableItems = items;
    this.updateCallback(processableItems);
  }
}
